/**
 * FE-SHARE-DEV-1 — per-device share modal device picker (server fleet page, not Overview cache).
 */

import { fetchFleetDevicesPage } from "./fleet-list-paginated.js";

/**
 * @param {object[]} items
 * @returns {object[]}
 */
export function filterSharePickerOwnDevices(items) {
  return (Array.isArray(items) ? items : []).filter((d) => d && !d.is_shared);
}

/**
 * @param {{ live?: boolean, cursor?: string | null, timeoutMs?: number, retries?: number }} [opts]
 */
export async function loadShareModalDevicePickerPage(opts = {}) {
  return fetchFleetDevicesPage({
    live: !!opts.live,
    cursor: opts.cursor != null ? String(opts.cursor) : null,
    timeoutMs: opts.timeoutMs,
    retries: opts.retries,
  });
}

/**
 * @param {number} loadedCount
 * @param {boolean} hasMore
 * @param {string} [bannerId]
 * @returns {string}
 */
export function shareModalDevicePickerTruncatedHtml(loadedCount, hasMore, bannerId = "shareDevPickTruncBanner") {
  if (!hasMore) return "";
  return (
    `<p class="badge offline" id="${bannerId}" data-share-dev-pick-truncated="1" style="margin:0 0 8px">` +
    `${loadedCount} own boards loaded — load more below for the rest.` +
    `</p>`
  );
}

/**
 * @param {object[]} items
 * @param {Set<string> | string[]} pickedIds
 * @param {(d: object, opts: { checked: boolean, disabled: boolean }) => string | null | undefined} renderRow
 * @returns {string}
 */
export function buildShareModalDevicePickerRowsHtml(items, pickedIds, renderRow) {
  const picked = pickedIds instanceof Set
    ? pickedIds
    : new Set((Array.isArray(pickedIds) ? pickedIds : []).map((x) => String(x)));
  const own = filterSharePickerOwnDevices(items);
  const rows = own
    .map((d) => renderRow(d, { checked: picked.has(String(d.device_id)), disabled: false }))
    .filter(Boolean);
  return rows.join("") || `<p class="muted">No own boards on this page.</p>`;
}

/**
 * @param {object[]} existing
 * @param {object[]} extra
 * @returns {object[]}
 */
export function mergeSharePickerDevicePages(existing, extra) {
  const out = Array.isArray(existing) ? existing.slice() : [];
  const seen = new Set(out.map((d) => String(d.device_id || "")));
  for (const d of Array.isArray(extra) ? extra : []) {
    const id = String(d.device_id || "");
    if (!id || seen.has(id)) continue;
    seen.add(id);
    out.push(d);
  }
  return out;
}
